export const environment = {
  production: false,
  serviceUrl: 'https://api-dev-dx.revyrie.co',
  vastUrl: 'https://dev-x.videobyte.com',
  epgGenresService: 'https://dev-epg.videobyte.com/main/api/genre',
  epgKeywordsService: 'https://dev-epg.videobyte.com/main/api/keyword',
  auth0: {
    domain: 'dev-xkh41bk6wz51mic6.us.auth0.com',
    clientId: 'yvhEqGTh0pLHzY2OtRcAYXWZdq3yf4et',
    audience: 'https://api.dxkulture.com',
  },
  aiInsightsMock: false,
};
